export const formatDate = isoString => {
  const date = new Date(isoString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${day} tháng ${month}, ${year}`;
};

export const formatRelativeTime = isoString => {
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date; // chênh lệch tính bằng milliseconds

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffYears = Math.floor(diffDays / 365);

  if (diffMinutes < 1) {
    return "Vừa xong";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} phút trước`;
  } else if (diffHours < 24) {
    return `${diffHours} giờ trước`;
  } else if (diffDays < 7) {
    return `${diffDays} ngày trước`;
  } else if (diffWeeks < 52) {
    return `${diffWeeks} tuần trước`;
  } else {
    return `${diffYears} năm trước`;
  }
};

export const formatCurrency = amount => {
  if (!amount) return "";
  return Math.floor(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
